module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-201.3c7c0876.svg";